<template>
  <b-modal v-model="showModal" centered no-close-on-backdrop no-close-on-esc hide-header>
    <div class="d-flex" style="gap: 7px">
      <div>
        <b-spinner small label="Small Spinner"></b-spinner>
        <b-spinner small label="Small Spinner" type="grow"></b-spinner>
      </div>
      <div>{{ FormMSG(1, 'OCR processing in progress...') }}</div>
    </div>
    <template #modal-footer>
      <div class="w-100 d-flex flex-row justify-content-center align-items-center">
        <b-button size="sm" variant="custom-outline-gray" @click="abortProcess">
          {{ FormMSG(2, 'Continue without OCR') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { abortInvoiceOcrProcess } from '@/cruds/expense.crud';
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

export default {
  name: 'DialogWaitingOcrInvoice',
  mixins: [languageMessages, globalMixin],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  watch: {
    show(newValue) {
      this.showModal = newValue;
    }
  },
  methods: {
    abortProcess() {
      abortInvoiceOcrProcess();
      this.$emit('process:aborted');
    }
  }
};
</script>
